import { z } from 'zod'

export const ContactFormSchema = (t: (key: string) => string) =>
  z.object({
    phoneNumber: z
      .string()
      .min(1, t('Validation_phone_required'))
      .regex(/^\d+$/, t('Validation_digits_only'))
      .length(8, t('Validation_phone_length')),
    name: z.string().min(1, t('Validation_name_required')),
    email: z.string().min(1, t('Validation_email_required')).email(t('Validation_invalid_email')),
    subject: z.string().min(1, t('Validation_subject_required')).max(200, t('Validation_subject_max')),
    message: z.string().min(1, t('Validation_message_required')).max(10000, t('Validation_message_max')),
  })

export type ContactForm = z.infer<ReturnType<typeof ContactFormSchema>>
